import React from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import loginAction from '../../actions/loginAction'
import resetPasswordAction from '../../actions/resetPasswordAction'
import Login from './login.component';
import ResetPasswordDialog from '../../components/resetPasswordDialog.component'
import {isMobileDevice} from '../../utils/generalUtils';
import ResolutionNotSupportedComponent from "../../components/resolutionNotSupported.component";

class LoginContainer extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         email: "",
         password: "",
         resetPasswordDialogOpen: false
      };
      this.toggleResetPasswordDialogState.bind(this);
   }

   toggleResetPasswordDialogState = () => {
      this.setState({
         resetPasswordDialogOpen: !this.state.resetPasswordDialogOpen
      });
   }

   handleInputChange(event) {
      this.setState({
         [event.target.id]: event.target.value
      });
   }

   handleLogin() {
      this.props.login(this.state.email, this.state.password);
   }

   handleResetPassword = (email) => {
      this.props.resetPassword(email);
   }

   renderLoginComponent() {
      return (
         <div>
            <Login handleInputChange = {this.handleInputChange.bind(this)}
                   handleLogin = {this.handleLogin.bind(this)}
                   handleForgotPassword = {this.toggleResetPasswordDialogState}
            />
            <ResetPasswordDialog
               open = {this.state.resetPasswordDialogOpen}
               handleClose = {this.toggleResetPasswordDialogState}
               resetPassword = {this.handleResetPassword.bind(this)}
            />
         </div>
      );
   }

   render() {
      return (
         isMobileDevice() ?
            <ResolutionNotSupportedComponent/> : this.renderLoginComponent()
      )
   }
}

const mapDispatchToProps = {
   login: loginAction,
   resetPassword: resetPasswordAction
}

LoginContainer.PropTypes  = {
   login: PropTypes.func.isRequired
};


export default connect(
   null,
   mapDispatchToProps
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/pages/login/login.container.js